const DashboardRoutes = {
    getDashboardData: 'admin/dashboard',
};

export default DashboardRoutes